import { createApiSlice } from "@common";
import {
    CRUD_PERSONAL_GENDER
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addPersonalGender",
        method: "post",
        url: CRUD_PERSONAL_GENDER,
        stateKey: "message",
    },
    {
        name: "getPersonalGender",
        method: "get",
        url: CRUD_PERSONAL_GENDER,
        stateKey: "data",
    },
    {
        name: "updatePersonalGender",
        method: "put",
        url: CRUD_PERSONAL_GENDER,
        stateKey: "message",
    },
    {
        name: "deletePersonalGender",
        method: "delete",
        url: CRUD_PERSONAL_GENDER,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "PersonalGender",
    apiConfig,
    customReducers,
);
const PersonalGenderSlice = slice;
// Export the slice's reducer
export default PersonalGenderSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addPersonalGender,
    getPersonalGender,
    updatePersonalGender,
    deletePersonalGender
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
